import CancelBackButton from "Common/Components/Buttons/CancelBackButton";
import CancelButton from "Common/Components/Buttons/CancelButton";
import LoadingSpinner from "Common/Components/LoaderErrorWrapper/LoadingSpinner";
import PageBreadcrumb from "Common/Components/PageBreadcrumb/PageBreadcrumb";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import FormHeader from "components/FormAndDetailHeader/FormAndDetailHeader";
import React, { useEffect } from "react";
import { Card, Row, Col, Table, Badge, Container } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { fetchCompanyById } from "slices/Masters/company/thunk";

interface Address {
  address: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  phone_number?: string;
}

interface ContactDetail {
  name: string;
  email: string;
  phone_number: string;
  designation?: string;
  contact_person_department?: string;
}

interface ShippingAddress {
  shipping_address_id: string;
  address: string;
  city: string;
  state: string;
  country: string;
  pincode: string;
  phone_number?: string;
}

interface CompanyData {
  id: string;
  company_name: string;
  company_email: string;
  branch_name: string;
  vendor_code: string;
  phone_number: string;
  industry: string;
  gst_type: string;
  gstin?: string | null;
  billing_address: Address;
  shippingAddresses: ShippingAddress[];
  contacts: ContactDetail[];
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

interface Props {
  company: CompanyData;
}

const CompanyViewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<any>();
  const [companyData, setCompanyData] = React.useState<CompanyData | null>(
    null
  );
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    if (id) {
      dispatch(fetchCompanyById(id))
        .unwrap()
        .then((res: any) => {
          setCompanyData(res.data?.data || res.data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id, dispatch]);

  return (
    <>
    {/* <style>
      {`
        span {
          margin-left:10px
        }
      `}
    </style> */}
      <PageContainer>
        <FormHeader
          title="Customer Details"
          firstLabel="Customer"
          secondLabel="Customer Details"
          handleArrowClick={() => navigate("/master/customer")}
        />
        <hr />

        {loading ? (
          <LoadingSpinner />
        ) : !companyData ? (
          <>
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="text-center py-5">
                  <h4>Customer not found</h4>
                  <Link to="/master/company" className="btn btn-primary">
                    Back to Customers
                  </Link>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <div className="mb-3">
            <Card.Body>
              <Row className="mb-3">
                <Col md={6}>
                  <p>
                    <strong>Customer Name: </strong>&nbsp;
                    {companyData.company_name || "-"}
                  </p>
                  <p>
                    <strong>Industry: </strong>&nbsp;
                    {companyData.industry || "-"}
                  </p>
                  <p>
                    <strong>Phone No.:</strong>&nbsp;
                    {companyData?.phone_number || "—"}
                  </p>
                  <p>
                    <strong>GST Type:</strong>&nbsp;
                    {companyData?.gst_type || "—"}
                  </p>
                </Col>
                <Col md={6}>
                <p>
                    <strong>Location Name:</strong>&nbsp;
                    {companyData?.branch_name || "—"}
                  </p>
        
                  <p>
                    <strong>Email:</strong>&nbsp;
                    {companyData?.company_email || "—"}
                  </p>
                  <p>
                    <strong>GST IN:</strong>&nbsp;
                    {companyData?.gstin || "—"}
                  </p>
          
             
                  <p>
                    <strong>Vendor Code:</strong>&nbsp;
                    {companyData?.vendor_code || "—"}
                  </p>
                </Col>
              </Row>
              <hr />

              <Row className="mb-3">
                <Col md={2}>
                  <p style={{ display: "flex", alignItems: "flex-start" }}>
                    <strong style={{ minWidth: "140px" }}>
                      Billing Address :
                    </strong>
                  </p>
                </Col>
                <Col md={4}>
                 <span>
                      {companyData.billing_address.address},{" "}
                      {companyData.billing_address.city}, <br />
                      {companyData.billing_address.state},{" "}
                      {companyData.billing_address.country},<br />
                      {companyData.billing_address.pincode}, Phone:{" "}
                      {companyData.billing_address.phone_number}
                    </span>
                </Col>
              </Row>
              <hr />

              <Row className="mb-3">
                <Col md={12}>
                  <h5>Shipping Address :</h5>
                </Col>

                <Row md={12}>
                  {companyData.shippingAddresses &&
                  companyData.shippingAddresses.length > 0 ? (
                    companyData.shippingAddresses.map(
                      (addr: any, index: number) => (
                        <>
                          {/* Address label */}
                          <Col
                            key={addr.shipping_address_id || index}
                            className="mb-2 mt-3"
                            md={2}
                          >
                            <strong>Address {index + 1} :</strong>
                          </Col>

                          {/* Address details */}
                          <Col className="mb-2 mt-3" md={4}>
                            {addr.address || "-"}, {addr.city || "-"}
                            <br />
                            {addr.state || "-"}, {addr.country || "-"}
                            <br />
                            {addr.pincode || "-"}, Phone:{" "}
                            {addr.phone_number || "-"}
                          </Col>
                        </>
                      )
                    )
                  ) : (
                    <span>-</span>
                  )}
                </Row>
              </Row>

              <hr />

              <Row className="mb-3">
                <Col md={12} className="mb-3">
                  <h5>Contact Details :</h5>
                </Col>
                <Row md={12}>
                  {companyData.contacts && companyData.contacts.length > 0 ? (
                    companyData.contacts.map((contact: any, index: number) => (
                      <>
                        {/* LEFT COLUMN – LABELS */}
                        <Col s={6} md={4} className="mb-3">
                          <p>
                            <strong>Contact {index+1}</strong>
                          </p>
                          <p>
                            <strong>Contact Name:</strong>{" "}
                            <span>{contact.name || "-"}</span> 
                          </p>
                          <p>
                            <strong>Designation:</strong>{" "}
                            <span>{contact.designation || "-"}</span>
                          </p>
                          <p>
                            <strong>Phone Number:</strong>{" "}
                            <span>{contact.phone_number || "-"}</span>
                          </p>
                          <p>
                            <strong>Email:</strong>{" "}
                            <span>{contact.email || "-"}</span>
                          </p>
                        </Col>
                      </>
                    ))
                  ) : (
                    <span>-</span>
                  )}
                </Row>
              </Row>

              <hr />

              <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
                <CancelButton showConfirmation={false} redirectTo={"/master/company"} />
              </div>
            </Card.Body>
          </div>
        )}
      </PageContainer>
    </>
  );
};

export default CompanyViewPage;
